<template>
    <!-- 结构 -->
    <ul id="groupRule"></ul>
</template>

<script>
import authorityImport from '@/libs/authority';
import userInfo from "@/api/module"
import listMixin from '../xc-ui/mixins/list';

export default {
    name: 'authoritySet',
    data() {
        return {
            data: [],
            roleId: null,
        }
    },
    components: {
    },
    methods: {
        //处理数据
        detailData: function (data) {
            var s_true = "s_true";
            var len = data.length;

            for (var i = 0; i < len; i++) {
                var childs1 = data[i].children;
                if (childs1.length > 0) {

                    for (var j = 0; j < childs1.length; j++) {
                        var childs2 = childs1[j].children;
                        var len2 = childs2.length;
                        if (len2 > 0) {
                            var sum2 = 0;
                            for (var k = 0; k < len2; k++) {
                                if (childs2[k].checked == true) {
                                    sum2++
                                }
                            }
                            if (sum2 === len2) {
                                childs1[j].checked = true;
                            } else if (sum2 == 0) {
                                childs1[j].checked = false;
                            } else {
                                childs1[j].checked = "s_true";
                            }
                            sum2 = 0;
                        }
                    }

                    var len1 = childs1.length;
                    var sum1 = 0;
                    var sum3 = 0;
                    for (var m = 0; m < len1; m++) {
                        if (childs1[m].checked == true) {
                            sum1++
                        } else if (childs1[m].checked == s_true) {
                            sum3++;
                        }
                    }
                    if (sum1 === len1) {
                        data[i].checked = true;
                    } else if (sum1 == 0 && sum3 == 0) {
                        data[i].checked = false;
                    } else {
                        data[i].checked = s_true;
                    }
                    sum1 = 0;
                    sum3 = 0;
                    childs1 = '';
                }
            }
            return data
        }
    },
    created() {
    },
    async mounted() {
        var _this=this;
        //   加载一下JS
        await authorityImport();

        this.roleId = this.$route.query.roleId;
        var obj={
            roleId:this.roleId
        };
        userInfo.listRoleModule(obj).then(function (success) {
            _this.data=_this.detailData(success.data);
            // 调用groupRule方法
            _this.$nextTick(function () {
                $("#groupRule").groupRule({ data: _this.data });
            })
        }).catch(function (error) {
            console.log(error)
        })


    }
}

// 获取树形控件数据
window.getTreeData=function () {
    var checked = $("#groupRule").find(".checked")
    var len = $("#groupRule").find(".checked").length;

    if (checked.length <= 0) {
        console.log("请勾选选项")
    }
    var i = 0,
        arr = [],
        name = [];
    $(checked).each(function () {
        arr[i] = $(this).attr("id");
        name[i] = $(this).parents('.btn-toggle').find('span[class="label-text"]').html();
        i++;
    });
    var ids = arr.join(",");
    var names = name.join(",");
    return {
        idsdata: ids,
        namedata: names
    };
}
</script>

<style  lang="scss">
    #groupRule{
        .authitem.auth1 span{
            color: #6e7a90 !important;
            background-color: #f3f6fb;
            font-size: 12px;
            height: 41px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .btn-toggle{
            font-size: 14px;
            height: 41px;
            display: flex;
            align-items: center;
            color: #6e7a90 !important;
        }
    }
</style>

